export default {
    ADD: 'ALERT_ADD',
    SHOW: 'ALERT_SHOW',
    READ: 'ALERT_READ',
    DISMISS: 'ALERT_DISMISS',
    DELETE: 'ALERT_DELETE',
    DELETING: 'ALERT_DELETING',
    LIST: 'ALERT_LIST'
};
